import type {CSSProperties} from "react";
import {forwardRef} from "react";
import cx from "../cx";
import {arrowStyles} from "./arrow.css";

type ArrowDirection = "horizontal" | "vertical";
type ArrowPointTo = "top" | "bottom" | "left" | "right";
type ArrowSize = keyof typeof arrowStyles.bySize;

const dirInfo: Record<ArrowPointTo, {dir: ArrowDirection}> = {
  top: {dir: "horizontal"},
  bottom: {dir: "horizontal"},
  left: {dir: "vertical"},
  right: {dir: "vertical"},
};

export type ArrowProps = {
  pointTo: ArrowPointTo;
  size: ArrowSize;
  style?: CSSProperties;
  className?: string;
};

const Arrow = forwardRef<HTMLDivElement, ArrowProps>(({pointTo, size, className, style}, ref) => {
  const {dir} = dirInfo[pointTo];
  return (
    <div
      ref={ref}
      style={style}
      className={cx(
        arrowStyles.base,
        arrowStyles.bySize[size],
        arrowStyles.byPosition[pointTo],
        arrowStyles.byDirAndSize[dir][size],
        className
      )}
    />
  );
});

export default Arrow;
